import { useEffect, useRef, useState } from "react";
import { salonInfo } from "@/mocks/content";

const InstagramIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <rect x="2" y="2" width="20" height="20" rx="5" /><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);
const LineIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <path d="M21 11.5C21 7.36 16.97 4 12 4S3 7.36 3 11.5c0 3.69 3.27 6.79 7.69 7.38.3.06.71.2.81.45.09.23.06.58.03.81l-.13.79c-.04.23-.18.9.79.49s5.22-3.08 7.12-5.27A6.6 6.6 0 0021 11.5z" />
  </svg>
);

export default function AccessSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="access" ref={sectionRef} className="py-24 md:py-40 bg-[#F4F2EE]">
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        <p className="text-[#8B7355] text-xs tracking-[0.4em] mb-3 font-light" style={{ fontFamily: "'Noto Serif JP', serif", opacity: visible ? 1 : 0, transition: "opacity 0.6s ease 0.2s" }}>ACCESS</p>
        <h2 className="text-[#2C2C2C] font-light mb-12 leading-tight" style={{ fontFamily: "'Noto Serif JP', serif", fontSize: "clamp(1.8rem,3.5vw,3rem)", opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(20px)", transition: "opacity 0.7s ease 0.3s, transform 0.7s ease 0.3s" }}>
          アクセス
        </h2>

        {/* Map */}
        <div className="w-full h-80 md:h-[420px] overflow-hidden mb-10" style={{ opacity: visible ? 1 : 0, transition: "opacity 0.8s ease 0.4s" }}>
          <iframe
            src={salonInfo.mapEmbedUrl}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="サロンの地図"
          />
        </div>

        {/* Address Card */}
        <div className="bg-[#FAFAF8] p-8 md:p-10 mb-16" style={{ opacity: visible ? 1 : 0, transition: "opacity 0.7s ease 0.5s" }}>
          <p className="text-[#2C2C2C] font-light text-sm leading-relaxed" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            {salonInfo.address}
          </p>
          <p className="text-[#4A4A4A] text-xs mt-2 font-light" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            渋谷駅より徒歩5分 / 表参道駅より徒歩8分
          </p>
        </div>

        {/* SNS */}
        <div className="text-center" style={{ opacity: visible ? 1 : 0, transition: "opacity 0.7s ease 0.6s" }}>
          <p className="text-[#8B7355] text-xs tracking-[0.4em] mb-4 font-light" style={{ fontFamily: "'Noto Serif JP', serif" }}>FOLLOW US</p>
          <h3 className="text-[#2C2C2C] font-light mb-8" style={{ fontFamily: "'Noto Serif JP', serif", fontSize: "clamp(1.5rem,3vw,2.5rem)", letterSpacing: "0.15em" }}>SNS</h3>
          <div className="flex items-center justify-center gap-6">
            {[
              { href: salonInfo.instagram, icon: <InstagramIcon />, label: "Instagram" },
              { href: salonInfo.line, icon: <LineIcon />, label: "LINE" },
            ].map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex flex-col items-center gap-2 group cursor-pointer"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-full border border-[#8B7355] text-[#8B7355] group-hover:bg-[#8B7355] group-hover:text-[#FAFAF8] transition-all duration-300">
                  {s.icon}
                </div>
                <span className="text-[#4A4A4A] text-xs tracking-[0.2em] font-light" style={{ fontFamily: "'Noto Serif JP', serif" }}>{s.label}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
